module.exports = __webpack_public_path__ + "img/edge.842096e1.png";